import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Menu/Nav";
import SideMenu from "../../Components/Menu/SideMenu";
import { SideMenuList } from "../../utils/constants";
import CreateChatBot from "./CreateChatBot";
import Templates from "./Templates";
import Box from "@mui/material/Box";
import { SidebarContextPrv } from "../../Contexts/SidebarContext";
import InstaTemplates from "./InstaTemplates";
import SubscribersPage from "./SubscribersPage";
import MmelinksPage from "./MmelinksPage";
import OptinFollowUp from "./OptinFollowUp";
import CampaignsDashboard from "./CampaignsDashboard";
import CustomAudiencePage from "./CustomAudiencePage";
function Dashboard() {
  const { menu }: any = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const checkParam = () => {
      const findParam: any = SideMenuList.find(
        (item: any) => item?.menu === menu,
      );
      if (findParam === undefined) navigate("/dashboard/chatbot");
    };
    checkParam();
  }, [navigate, menu]);

  const broadcast = localStorage.getItem("broadcastConnection");

  return (
    <div id="wrapper" className="left-side-menu-dark">
      <SidebarContextPrv>
        <Navbar />
        <Box sx={{ display: "flex" }}></Box>
        <SideMenu menu={menu} />
        {menu === SideMenuList?.[0].menu ? <CreateChatBot /> : null}
        {menu === SideMenuList?.[1].menu ? <Templates /> : null}
        {menu === SideMenuList?.[2].menu ? <InstaTemplates /> : null}
        {menu === SideMenuList?.[3].menu ? <SubscribersPage /> : null}
        {menu === SideMenuList?.[4].menu ? <MmelinksPage /> : null}
        {menu === SideMenuList?.[5].menu ? <OptinFollowUp /> : null}
        {broadcast === "marketing-message" && menu === "dmcampaigns" ? (
          <CampaignsDashboard />
        ) : null}
        {broadcast === "marketing-message" && menu === "customaudiences" ? (
          <CustomAudiencePage />
        ) : null}
      </SidebarContextPrv>
    </div>
  );
}

export default Dashboard;
